module.exports = __webpack_public_path__ + "img/1697118874431.e5c4b059.jpg";